/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Section_ServiceInputs */

const de_commons_footer_section_service = /** @type {(inputs: Commons_Footer_Section_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundenservice`)
};

/** @type {(inputs: Commons_Footer_Section_ServiceInputs) => LocalizedString} */
const en_commons_footer_section_service = de_commons_footer_section_service;

/**

* @param {Commons_Footer_Section_ServiceInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_section_service = /** @type {((inputs?: Commons_Footer_Section_ServiceInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Section_ServiceInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_section_service(inputs)
	return en_commons_footer_section_service(inputs)
});